// ELOCOTACAO sitekey
// '6Ldqau4dAAAAAM8BHHNinWSK5kvMjmR9K9pLRzDH';

// LOCALHOST sitekey
// '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';

export const SITEKEY = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI';
